let unlocked = false;

function context() {
  const AudioContextClass = window.AudioContext || window.webkitAudioContext;
  return AudioContextClass ? new AudioContextClass() : null;
}

export async function unlockNotificationSound() {
  if (unlocked || typeof window === "undefined") return true;
  const ctx = context();
  if (!ctx) return false;
  const buffer = ctx.createBuffer(1, 1, 22050);
  const source = ctx.createBufferSource();
  source.buffer = buffer;
  source.connect(ctx.destination);
  source.start(0);
  if (ctx.state === "suspended") await ctx.resume().catch(() => {});
  unlocked = true;
  setTimeout(() => ctx.close().catch(() => {}), 250);
  return true;
}

export function playNotificationSound(kind = "message") {
  if (typeof window === "undefined") return;
  if (localStorage.getItem("nexora-notification-sound") === "off") return;
  const ctx = context();
  if (!ctx) return;
  const master = ctx.createGain();
  master.gain.setValueAtTime(0.0001, ctx.currentTime);
  master.gain.exponentialRampToValueAtTime(0.18, ctx.currentTime + 0.015);
  master.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.52);
  master.connect(ctx.destination);

  const sequence = kind === "urgent"
    ? [{ at: 0, freq: 880 }, { at: 0.13, freq: 988 }, { at: 0.26, freq: 1175 }]
    : [{ at: 0, freq: 784 }, { at: 0.12, freq: 1046 }];

  sequence.forEach(({ at, freq }) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(freq, ctx.currentTime + at);
    gain.gain.setValueAtTime(0.0001, ctx.currentTime + at);
    gain.gain.exponentialRampToValueAtTime(0.9, ctx.currentTime + at + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + at + 0.18);
    osc.connect(gain);
    gain.connect(master);
    osc.start(ctx.currentTime + at);
    osc.stop(ctx.currentTime + at + 0.2);
  });

  setTimeout(() => ctx.close().catch(() => {}), 850);
}
